import { CIcon } from '~/icons/types'

export const ciVans: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.9 13.666v-.02a4.274 4.274 0 0 0-.61-2.37.608.608 0 0 1-.07-.1 6.014 6.014 0 0 0-.91-.91.498.498 0 0 0-.08-.07 6.001 6.001 0 0 1-.83-.85c-.27-.38-.52-.74-.74-1.07-.25-.38-.47-.72-.63-.98-.24-.4-.37-.64-.37-.64s-.02-.02-.02-.03a2.441 2.441 0 0 0-2.07-1.13H1.725A1.63 1.63 0 0 0 .1 7.126v7.81a1.63 1.63 0 0 0 1.63 1.63h.51c-.01-.12-.02-.23-.02-.34a3.255 3.255 0 1 1 6.51 0c0 .12-.01.22-.02.34h6.03c-.01-.12-.02-.22-.02-.34a3.255 3.255 0 1 1 6.51 0c0 .11-.01.22-.02.33h1.14a1.52 1.52 0 0 0 1.11-.47 1.5 1.5 0 0 0 .45-1.11l-.01-1.31Zm-8.39-3.04-.01-1.66v-1.08h3.66c.29.45.99 1.41 1.45 2.03.06.1.54.62.61.71h-5.71Z'
    },
    {
      d:
        'M17.977 13.96a2.271 2.271 0 0 0-2.246 2.603 2.269 2.269 0 0 0 4.514-.328 2.272 2.272 0 0 0-2.268-2.274Zm-12.502 0a2.271 2.271 0 0 0-1.483 3.989 2.27 2.27 0 1 0 1.483-3.988Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'vans',
  type: 'solid'
}
